import update from 'immutability-helper';
import { PROGRESS, SUCCESS, FAILED } from "../config/types";
import {
  WAY_FOR_PAY_MERCHANTS_GET_LIST_PROGRESS,
  WAY_FOR_PAY_MERCHANTS_GET_LIST_SUCCESS,
  WAY_FOR_PAY_MERCHANTS_GET_LIST_FAILED,
  WAY_FOR_PAY_MERCHANTS_FORM_SUBMIT_PROGRESS,
  WAY_FOR_PAY_MERCHANTS_FORM_SUBMIT_SUCCESS,
  WAY_FOR_PAY_MERCHANTS_FORM_SUBMIT_FAILED,
  WAY_FOR_PAY_MERCHANTS_GET_MERCHANT_PROGRESS,
  WAY_FOR_PAY_MERCHANTS_GET_MERCHANT_SUCCESS,
  WAY_FOR_PAY_MERCHANTS_GET_MERCHANT_FAILED,
  WAY_FOR_PAY_MERCHANTS_CLEAR_STATE,
} from '../actions/WayForPayMerchantsAction';

const initialState = {
  loadListStatus: '', // progress/success/failed
  loadActiveStatus: '', // progress/success/failed
  submitStatus: '', // progress/success/failed
  list: [],
  pagination: {},
  active: {},
  statistic: {},
};

export default function (state = initialState, action) {
  switch (action.type) {
    case WAY_FOR_PAY_MERCHANTS_GET_LIST_PROGRESS: {
      return update(
        state, {
          list: { $set: [] },
          pagination: { $set: {} },
          loadListStatus: { $set: PROGRESS },
        },
      );
    }
    case WAY_FOR_PAY_MERCHANTS_GET_LIST_SUCCESS: {
      return update(
        state, {
          list: { $set: action.payload.list },
          pagination: { $set: action.payload.pagination },
          loadListStatus: { $set: SUCCESS },
        },
      );
    }
    case WAY_FOR_PAY_MERCHANTS_GET_LIST_FAILED: {
      return update(
        state, {
          list: { $set: [] },
          pagination: { $set: {} },
          loadListStatus: { $set: FAILED },
        },
      );
    }
    case WAY_FOR_PAY_MERCHANTS_FORM_SUBMIT_PROGRESS: {
      return update(
        state,
        { submitStatus: { $set: PROGRESS } },
      );
    }
    case WAY_FOR_PAY_MERCHANTS_FORM_SUBMIT_SUCCESS: {
      return update(
        state,
        {
          submitStatus: { $set: SUCCESS },
        },
      );
    }
    case WAY_FOR_PAY_MERCHANTS_FORM_SUBMIT_FAILED: {
      return update(
        state,
        { submitStatus: { $set: FAILED } },
      );
    }
    case WAY_FOR_PAY_MERCHANTS_GET_MERCHANT_PROGRESS: {
      return update(
        state, {
          active: { $set: {} },
          statistic: { $set: {} },
          loadActiveStatus: { $set: PROGRESS },
        },
      );
    }
    case WAY_FOR_PAY_MERCHANTS_GET_MERCHANT_SUCCESS: {
      return update(
        state, {
          active: { $set: action.payload.merchant },
          statistic: { $set: action.payload.statistic || {} },
          loadActiveStatus: { $set: SUCCESS },
        },
      );
    }
    case WAY_FOR_PAY_MERCHANTS_GET_MERCHANT_FAILED: {
      return update(
        state, {
          active: { $set: {} },
          statistic: { $set: {} },
          loadActiveStatus: { $set: FAILED },
        },
      );
    }
    case WAY_FOR_PAY_MERCHANTS_CLEAR_STATE: {
      return update(
        state,
        {
          loadListStatus: { $set: '' },
          loadActiveStatus: { $set: '' },
          submitStatus: { $set: '' },
          list: { $set: [] },
          pagination: { $set: {} },
          active: { $set: {} },
          statistic: { $set: {} },
        },
      );
    }
    default:
      return state;
  }
}
